import { render } from "./A_Puppies.vue?vue&type=template&id=683ead16&scoped=true"
import script from "./A_Puppies.vue?vue&type=script&lang=js"
export * from "./A_Puppies.vue?vue&type=script&lang=js"

import "./A_Puppies.vue?vue&type=style&index=0&id=683ead16&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683ead16"]])

export default __exports__